/* EWC · PDP · arrastar a divisória da comparação antes/depois. */
(function () {
  function ligar(container) {
    var antes = container.querySelector('.before-image');
    var botao = container.querySelector('.slider-button');
    var linha = container.querySelector('.comparison-divider-line');
    if (!antes || !botao) return;
    var arrastando = false;

    function posicionar(clientX) {
      var r = container.getBoundingClientRect();
      var pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      botao.style.left = pct + '%';
      if (linha) linha.style.left = pct + '%';
    }
    function inicio(e) {
      arrastando = true;
      botao.classList.add('dragging');
      posicionar(e.touches ? e.touches[0].clientX : e.clientX);
      e.preventDefault();
    }
    function mover(e) {
      if (!arrastando) return;
      posicionar(e.touches ? e.touches[0].clientX : e.clientX);
    }
    function fim() { arrastando = false; botao.classList.remove('dragging'); }

    botao.addEventListener('mousedown', inicio);
    botao.addEventListener('touchstart', inicio, { passive: false });
    container.addEventListener('click', function (e) { if (!arrastando) posicionar(e.clientX); });
    document.addEventListener('mousemove', mover);
    document.addEventListener('touchmove', mover, { passive: true });
    document.addEventListener('mouseup', fim);
    document.addEventListener('touchend', fim);
  }
  function todas() { document.querySelectorAll('.before-after-section .slider-container').forEach(ligar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas);
  else todas();
})();
